// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__B3vQ7","slider":"Toggle_slider__0labG"};